import { render, staticRenderFns } from "./DevSkillScore.vue?vue&type=template&id=818d7b66&scoped=true&"
import script from "./DevSkillScore.vue?vue&type=script&lang=js&"
export * from "./DevSkillScore.vue?vue&type=script&lang=js&"
import style0 from "./DevSkillScore.vue?vue&type=style&index=0&id=818d7b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818d7b66",
  null
  
)

export default component.exports